module.exports = __webpack_public_path__ + "assets/images/sql-clone-logo.5f8db89df95f8e88952dd93a86ba47f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/getting-started/sql-clone-logo.png
// module id = 1067
// module chunks = 0